import React from "react";
import "../Terms&Conditions/TermsAndConditions.css";

export const TermsAndConditionsServices = () => {
  return (
    <div className="container">
      <div className="termsHeader mt-3">
        <h2>Terms & Conditions of Service (for Users/Clients) </h2>
        <p>
          <b> Effective Date: 1-Oct-2025 </b>
          Welcome to Listen Aura India Private Limited. By accessing or using
          our services-online or in person-you agree to the following terms:
        </p>
      </div>
      <div className="termsContainer">
        <div className="terms-list-content">
          <div className="list-header">Nature of Service</div>
          <div className="terms-content">
            <p>
              Listen Aura provides empathetic listening only, not clinical
              therapy or medical treatment.
            </p>

            <p>
              We do not diagnose, prescribe, or provide professional mental
              health therapy.
            </p>

            <p>
              Listeners are trained for empathetic communication but are not
              licensed counsellors unless explicitly stated.
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Eligibility</div>
          <div className="terms-content">
            <p>
              <b>Our services are open to: </b>
            </p>
            <p>Adults aged 18+ (minors require parental consent). </p>

            <p>Individuals of all backgrounds, genders, and cultures. </p>

            <p>
              Clients comfortable communicating in English, Hindi, Kannada,
              Telugu, Malayalam, Arabic, or French.
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">User Responsibility</div>
          <div className="terms-content">
            <p>You agree to be respectful and truthful during sessions.</p>

            <p>
              Abusive, threatening, or inappropriate behaviour will not be
              tolerated.
            </p>
            <p>
              You acknowledge sessions are for support only, not crisis
              intervention.
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Confidentiality</div>
          <div className="terms-content">
            <p>Sessions are strictly confidential. </p>
            <p>
              <b>Confidentiality may only be broken if: </b>
            </p>
            <p>There is risk of harm to yourself or others.</p>
            <p>We are legally required to disclose. </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Scheduling & Cancellation</div>
          <div className="terms-content">
            <p>
              Appointments must be booked in advance (via WhatsApp or online).
            </p>

            <p>Cancel/reschedule at least 6 hours in advance.</p>
            <p>
              Repeated last-minute cancellations may result in restricted
              access.
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Payment & Refunds</div>
          <div className="terms-content">
            <p>
              Some sessions are free; others may be paid. Fees will be
              communicated in advance.
            </p>

            <p>No refunds once a session is completed. </p>
            <p>
              Refund rules for pre-booked sessions are covered in our Refund &
              Cancellation Policy.
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Certification & Training</div>
          <div className="terms-content">
            <p>
              Our Empathetic Listener Training is an 8-week program, available
              online/offline.
            </p>

            <p>Certification is granted only upon full completion. </p>
            <p>
              Certification rights remain with
              <b>Listen Aura India Pvt Ltd</b>.
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Limitation of Liability</div>
          <div className="terms-content">
            <p>
              Listen Aura is not responsible for actions or decisions taken by
              clients post-sessions.
            </p>

            <p>
              The service is not a substitute for therapy, medication, or
              emergency intervention.
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Modifications</div>
          <div className="terms-content">
            <p>
              We may update these terms periodically. Continued use constitutes
              acceptance of updated terms.
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Contact Us</div>
          <div className="terms-content">
            <p>
              For support or questions, reach us via Email:{" "}
              <a href="mailto:connect@listenaura.com">connect@listenaura.com</a>
              , WhatsApp:{" "}
              <a href="https://wa.me/916366636157" target="_blank">
                +91-6366636157
              </a>
              , or through our official website {" "}
              <a href="https://www.listenaura.com" target="_blank">
                www.listenaura.com
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
